module.exports = __webpack_public_path__ + "img/visa.123c6f2a.svg";